import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { RouterModule } from '@angular/router';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { BisSecurityDirective } from './bis-security.directive';
import { UtilityModule } from '../utility/utility.module';

@NgModule({
  declarations: [UnauthorizedComponent, AuthCallbackComponent, BisSecurityDirective],
  imports: [
    CommonModule,
    RouterModule,
    UtilityModule,
  ],
  exports: [UnauthorizedComponent, BisSecurityDirective],
})
export class AuthModule { }
